export default __webpack_public_path__ + "static/media/pic7.b5e2c147.svg";